import { useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { api, messageErreur } from "@/lib/api";
import { useRefs, versOptions } from "@/lib/referentiels";
import { ChoixListe } from "@/pages/parametres/ChoixListe";

const dansUneHeure = () => { const d = new Date(Date.now() + 3600000); d.setMinutes(0, 0, 0); return new Date(d - d.getTimezoneOffset() * 60000).toISOString().slice(0, 16); };

export const TacheDialog = ({ ouvert, setOuvert, ficheId, onCree }) => {
  const refs = useRefs();
  const [f, setF] = useState({ type: "rappel", echeance: dansUneHeure(), assigne_a: "", note: "" });
  const envoyer = async (e) => {
    e.preventDefault();
    try {
      await api.post(`/fiches/${ficheId}/taches`, { ...f, echeance: new Date(f.echeance).toISOString(), assigne_a: f.assigne_a || null });
      toast.success("Prochaine action planifiée.");
      setOuvert(false); onCree();
    } catch (err) { toast.error(messageErreur(err)); }
  };
  return (
    <Dialog open={ouvert} onOpenChange={setOuvert}>
      <DialogContent className="at-popover max-w-[calc(100vw-24px)] sm:max-w-md" data-testid="task-dialog">
        <DialogHeader><DialogTitle>Planifier une action</DialogTitle></DialogHeader>
        <form onSubmit={envoyer} className="space-y-3">
          <ChoixListe label="Type" valeur={f.type} onChange={(v) => setF({ ...f, type: v })} options={versOptions(refs?.types_tache)} testId="task-type-select" />
          <label className="block"><span className="at-label block mb-1.5">Date et heure</span>
            <input type="datetime-local" required value={f.echeance} onChange={(e) => setF({ ...f, echeance: e.target.value })} className="at-input" data-testid="task-datetime-input" /></label>
          {refs?.equipe?.length > 0 && <ChoixListe label="Assigné à" valeur={f.assigne_a} onChange={(v) => setF({ ...f, assigne_a: v })} placeholder="Moi"
            options={refs.equipe.map((u) => ({ code: u.id, label: u.nom }))} testId="task-assignee-select" />}
          <input value={f.note} onChange={(e) => setF({ ...f, note: e.target.value })} placeholder="Note (facultatif)" className="at-input" data-testid="task-note-input" />
          <button type="submit" className="at-btn at-btn-primary w-full" data-testid="task-submit-button">Planifier</button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
